export function convertToWhatsAppEncodedText(texto: string): string {
  // Reemplaza los espacios en blanco con "%20"
  return texto.replace(/ /g, '%20');
}
